
/* -----------------------------------------------------
スライド
------------------------------------------------------ */
$("#slide2409 ul").slick({
    fade: true,
    autoplay: true, // 自動再生
    autoplaySpeed: 4000, // 再生速度（ミリ秒設定） 1000ミリ秒=1秒
    slidesToShow: 1, // 表示するスライド枚数
    slidesToScroll: 1,// スライドする数
    speed: 2000,
});




/* --------------------------------------------------------------------
ローディング
-------------------------------------------------------------------- */
window.onload = function () {
    const spinner = document.getElementById('loading');
    spinner.classList.add('loaded');

    /* --------------------------------------------------------------------
    インビューここに入れる
    -------------------------------------------------------------------- */
    $(function () {
        $(".fadeIn").on("inview", function () {
            $(this).addClass("active");
        });
        $(".fadeUp").on("inview", function () {
            $(this).addClass("active");
        });
        $(".inview").on("inview", function () {
            $(this).addClass("active");
        });
    }); 


    /* -----------------------------------------------------
    メインビジュアル
    ------------------------------------------------------ */

    $(document).ready(function () {
        // img-text01 のアニメーション
        const imgText01 = $('.img-text01');
        const spans = $('#mv2409 .line span');

        // 最初のラインのアニメーションが開始する前に img-text01 を表示
        setTimeout(function () {
            imgText01.addClass('show');

            // img-text01 が表示された0.3秒後に各 span 要素に show クラスを追加
            setTimeout(function () {
                spans.each(function () {
                    $(this).addClass('show');
                });
            }, 300);
        }, 100);

        // 最後のラインのアニメーションが終了した後に img-text02 を表示
        spans.last().on('animationend', function () {
            const imgText02 = $('.img-text02');
            imgText02.addClass('show');

            $(document).ready(function () {
                // img-text02 が表示された後に .spoon と .ginger に .show を追加
                setTimeout(function () {
                    $('.spoon').addClass('show');
                    $('.ginger').addClass('show');
                    
                    
                    setTimeout(function () {
                        $('.jk').addClass('show');
                        $('.boy').addClass('show');
                    }, 1000); // アニメーションの終了時間後に .jk に .show クラスを追加
                }, 300); // 300ms 待ってから .spoon と .ginger に .show クラスを追加
            });
        });
    });
}


/* -----------------------------------------------------
ヒストリーページ 商品一覧の高さ
------------------------------------------------------ */
function adjustHeight() {
    var width = $('#historyPage #product ul li').width();
    var height, padding;
  
    padding = width / 420 * 100; 
  
     // 画面幅が480px以下の場合
     if (window.innerWidth <= 480) {
      height = width / 340 * 610;  // 480px以下の時の高さ
    } 
    // 画面幅が768px以下の場合
    else if (window.innerWidth <= 768) {
      height = width / 340 * 530;  // 768px以下の時の高さ
    } 
    // それ以上の場合 
    else {
      height = width / 340 * 440;  // 768pxより大きい時の高さ
    }
  
    $('#historyPage #product ul li').css('min-height', height);
    $('#historyPage #product ul li').css('padding-top', padding);
  }
  
  // 初回実行
  adjustHeight();
  
  // 画面幅が変わったときに実行
  $(window).resize(function() {
    adjustHeight();
  });

/* -----------------------------------------------------
ヘッダー現在地
------------------------------------------------------ */
$(document).ready(function() {
    var currentUrl = window.location.href; // 現在のURLを取得
    $('.header_nav li a').each(function() {    // ヘッダーリンクをループ
        var linkUrl = $(this).attr('href'); // 各リンクのURLを取得
        if (currentUrl.indexOf(linkUrl) !== -1) { // 現在のURLにリンクが含まれているかチェック
            $(this).closest('li').addClass('current'); // リンク先のliに.currentを付与
            $(this).on('click', function(e) {
                e.preventDefault(); // クリック無効化
            });
        }
    });
});


/* -----------------------------------------------------
幅・高さ
------------------------------------------------------ */
